<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.btn-info.disabled, .btn-info:disabled {
  cursor: no-drop;
}
</style>
<template>
  <CCard>
    <label for="">
      <h5 class="ml-3 mt-4 text-bold">Riwayat Pelatihan</h5>
    </label>
    <CCardBody>
      <CRow class="px-3 mb-5 font-weight-bold">
        <div class="col-md-6">
          <label class="text-bold ml-n3">SKP IAPI</label>
          <div class="row">
            <div
              class="text-white col-md-6 text-bold col-6 border border-white bg-primary text-left justify-content-center p-3"
              style="height: 50px"
            >
              PPL Terstruktur
            </div>
            <div
              class="col-md-6 border border-white text-bold col-6 p-3 justify-content-center text-left"
              style="background-color: rgb(220, 231, 235); height: 50px"
            >
              {{ count_skp_terstruktur }} SKP
            </div>
          </div>
          <div class="row">
            <div
              class="text-white col-md-6 text-bold col-6 border border-white bg-primary text-left justify-content-center p-3"
              style="height: 50px"
            >
              PPL Tidak Terstruktur
            </div>
            <div
              class="col-md-6 text-bold col-6 border border-white p-3 justify-content-center text-left"
              style="background-color: rgb(220, 231, 235); height: 50px"
            >
              {{ count_skp_tidak_terstruktur }} SKP
            </div>
          </div>
          <div class="row">
            <div
              class="text-white col-md-6 text-bold col-6 border border-white bg-primary text-left justify-content-center p-3"
              style="height: 50px"
            >
              PPL Berbasis Penilaian
            </div>
            <div
              class="col-md-6 text-bold col-6 border border-white p-3 justify-content-center text-left"
              style="background-color: rgb(220, 231, 235); height: 50px"
            >
              {{ count_assesment }} SKP
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label class="text-bold ml-2">SKP NON IAPI</label>
          <div class="row ml-2">
            <div
              class="text-white col-md-6 text-bold col-6 border border-white bg-primary text-left justify-content-center p-3"
              style="height: 75px"
            >
              Pengajuan SKP Tidak Terstruktur
            </div>
            <div
              class="col-md-6 border border-white text-bold col-6 p-4 justify-content-center text-left"
              style="background-color: rgb(220, 231, 235); height: 75px"
            >
              {{ count_non_iapi_perubahan }} SKP
            </div>
          </div>
          <div class="row ml-2">
            <div
              class="text-white col-md-6 text-bold col-6 border border-white bg-primary text-left justify-content-center p-3"
              style="height: 75px"
            >
              Pengajuan SKP Tidak Terstruktur Ke Terstruktur
            </div>
            <div
              class="col-md-6 text-bold col-6 border border-white p-4 justify-content-center text-left"
              style="background-color: rgb(220, 231, 235); height: 75px"
            >
              {{ count_ap_non_terstruktur }} SKP
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="row">
            <div
              class="text-white col-md-6 text-bold col-6 border border-white bg-primary text-left justify-content-center p-3"
              style="height: 50px"
            >
              Total SKP
            </div>
            <div
              class="col-md-6 border border-white text-bold col-6 p-3 justify-content-center text-left"
              style="background-color: rgb(220, 231, 235); height: 50px"
            >
              {{ getTotalSkp() }} SKP
            </div>
          </div>
        </div>
      </CRow>
      <!-- <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
        </CCol>
      </CRow> -->
      <CRow>
        <CCol lg="12" class="table-responsive mt-2">
          <CDataTable
            style="widht:100% !important" 
            :items="items" 
            :fields="fields"           
            hover 
            sorter            
          >
            <template #no="{index}">
              <td class="py-2">
                {{ indexed == 0 ? index + 1 : index + indexed + 1 }}
              </td>
            </template>
            <template #nama_pelatihan="{item}">
              <td>
                <div style="line-height:22px">
                  <span class="font-weight-bold">
                  {{ item.nama_pelatihan }}
                  </span><br>
                  <small >{{ getKatalog(item) }}</small>
                </div>
              </td>
            </template>    
            <template #tanggal_pelaksanaan="{item}">
              <td class="text-center">{{ item.tgl_mulai }} - {{ item.tgl_akhir }}</td>
            </template>
            <template #skp_terstruktur="{item}">
              <td class="font-weight-bold text-center">{{ item.skp_terstruktur ? item.skp_terstruktur : "0" }}</td>
            </template>
            <template #skp_tidak_terstruktur="{item}">
              <td class="font-weight-bold text-center">{{ item.skp_tidak_terstruktur ? item.skp_tidak_terstruktur : "0" }}</td>
            </template>
            <template #skp_berbasis_penilaian="{item}">
              <td class="font-weight-bold text-center">{{ item.skp_assessment ? item.skp_assessment : "0" }}</td>
            </template>
          </CDataTable>
          <!-- <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          /> -->
        </CCol>
      </CRow>

    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import PelaporanSkpService from "@/services/keanggotaan/pelaporan-skp.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from "@/mixins/exportUtils";


const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_pelatihan",
    label: "Nama Pelatihan",
    sorter: true,
    filter: true,
  },
  {
    key: "tanggal_pelaksanaan",
    label: "Tanggal Pelaksanaan",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "skp_terstruktur",
    label: "SKP Terstruktur",
    sorter: true,
    filter: true,    
    _style: "text-align: center"
  },
  {
    key: "skp_tidak_terstruktur",
    label: "SKP Tidak Terstruktur",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
  {
    key: "skp_berbasis_penilaian",
    label: "SKP Berbasis Penilaian",
    sorter: true,
    filter: true,
    _style: "text-align: center"
  },
];

export default {
  name: 'pelaporan-skp',

  mixins: [AlertUtils, exportUtils],

  data() {
    return {
      items: [],
      fields,
      currentPage: 0,
      pagination: {
        totalPages: 0
      },
      search: '',
      pageSize: "10",
      count_skp_terstruktur: 0,
      count_skp_tidak_terstruktur: 0,
      count_assesment: 0,
      count_non_iapi_perubahan: 0,
      count_ap_non_terstruktur: 0,
      indexed: 0
    };
  },

  mounted() {
    this.getData()
  },

  watch: {
    search: function(val) {
      if(val != "") {
          clearTimeout(this.timeout);
          var vm = this
          this.timeout = setTimeout(function () {
              // enter this block of code after 1 second
              // handle stuff, call search API etc.
              var searchVar = vm.search.trimStart();
              var searchFinal = searchVar.trimEnd();

              // vm.getData("0", vm.pageSize, searchFinal, vm.kategori.idKategoriAnggota,vm.tahun);
          }, 1000);
      } else {
        // this.getData("0", this.pageSize, this.search, this.kategori.idKategoriAnggota,this.tahun);
      }
     
    },

    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * 10;
      // this.getData(val - 1, this.pageSize, this.search, this.kategori.idKategoriAnggota,this.tahun);
    },
  },

  methods: {
    getTotalSkp() {
        return parseInt(this.count_skp_terstruktur) +
                parseInt(this.count_skp_tidak_terstruktur) +
                parseInt(this.count_assesment) +
                parseInt(this.count_non_iapi_perubahan) +
                parseInt(this.count_ap_non_terstruktur);
    },
    getKatalog(value) {
        if(value.katalog) {

            return value.katalog.join(', ')
        } else {
            console.log("TIDAK ADA KATALOG")
            return ''
        }

    },
    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;

      var tahun = this.$route.query.tahun;
      var id_user = this.$route.query.id_user;

      PelaporanSkpService.getPelaporanSkpDetail(tahun, id_user)
        .then((response) => {
          loader.hide();
          vm.items = response.data.data;
          console.log("ini data "+vm.data);
          vm.count_skp_terstruktur = response.data.count_skp_terstruktur;
          vm.count_skp_tidak_terstruktur =
            response.data.count_skp_tidak_terstruktur;
          vm.count_assesment = response.data.count_skp_assesment;
          vm.count_non_iapi_perubahan = response.data.count_non_iapi_perubahan;
          vm.count_ap_non_terstruktur = response.data.count_ap_non_terstruktur;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    changePageSize(e) {    
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search, this.kategori.idKategoriAnggota);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search, this.kategori.idKategoriAnggota);
    },

    filterData() {
      this.getData("0", this.pageSize, this.search, this.kategori.idKategoriAnggota,this.tahun);
    },

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
